import { render, staticRenderFns } from "./TxRowSkeletonSimple.vue?vue&type=template&id=1cd7c2ba"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports